import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/audit/ui-edit");

export const Route = createFileRoute("/audit/ui-edit")({
  head: () => ({
    meta: [
      { title: "UI edits — LevelLoad" },
      { name: "description", content: "User edits and feed overwrites recorded by LevelLoad." },
      { property: "og:title", content: "UI edits — LevelLoad" },
      {
        property: "og:description",
        content: "User edits and feed overwrites recorded by LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
